var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useContext } from "react";
import { willHold } from "../components/SpinnerAndErrorer/SpinnerAndErrorer";
import { FilterContext, updateFilters } from "../providers/FilterProvider";
import { useGetLeadershipRisksQuery, useGetLeadershipScoresQuery, useGetLeadershipOverviewQuery, useGetLeaderAtRiskScoresQuery, useGetPositionSuccessionOverviewQuery, useGetPositionSuccessionScoresQuery, useGetPositionSuccessionRisksQuery, useGetLeaderedSuccessionOverviewQuery, useGetLeaderedSuccessionScoresQuery, useGetLeaderedSuccessionRisksQuery, useGetLeaderAtRiskOverviewQuery, useGetLeadersAtRiskRisksQuery, useGetHeatmapAggregation, useGetLookupsFiltersQuery, getClientId, } from "../store/api/core";
var ALL_ROW_KEY = "ALL_row";
var ALL_COL_KEY = "ALL_col";
function fillEmpties(data, xLength, yLength, fillEmpty) {
    return Array.from(Array(yLength).keys()).map(function (yIndex) {
        return Array.from(Array(xLength).keys()).map(function (xIndex) { return (data[yIndex] || [])[xIndex] || fillEmpty(); });
    });
}
export function useHeatmap(useGetOverviewQuery, useGetScoresQuery, useGetRisksQuery, fillEmpty, scoreType, riskRole, allLabels, additionalParameters) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    if (allLabels === void 0) { allLabels = { x: "All Functions", y: "All Levels" }; }
    if (additionalParameters === void 0) { additionalParameters = {}; }
    var getFilters = useContext(FilterContext).getFilters;
    var filters = __assign(__assign({}, getFilters()), { scoreType: getFilters().dashboardScoreType });
    var scoresResponse = useGetScoresQuery(__assign({ filters: filters }, additionalParameters));
    var overview = useGetOverviewQuery({});
    var risksResponse = useGetRisksQuery({
        filters: filters,
        scoreType: scoreType,
        role: riskRole,
    });
    var headersConditions = [overview];
    var scoresConditions = [overview, scoresResponse, risksResponse];
    if (willHold(headersConditions)) {
        return { scoresConditions: scoresConditions, headersConditions: headersConditions };
    }
    var indexForLevelId = (_a = overview.data) === null || _a === void 0 ? void 0 : _a.indexForLevelId;
    var dataBreakdownHeaders = (_b = overview.data) === null || _b === void 0 ? void 0 : _b.dataBreakdownHeaders;
    var functionIndexes = ((_c = overview.data) === null || _c === void 0 ? void 0 : _c.functionIndexes) || {};
    var xHeaders = Object.entries(indexForLevelId || {}).reduce(function (result, _a) {
        var levelId = _a[0], index = _a[1];
        result[index] = levelId;
        return result;
    }, [allLabels.y]);
    var yHeaders = __spreadArray([allLabels.x], (((_d = overview.data) === null || _d === void 0 ? void 0 : _d.primaryFunctions) || []), true);
    var rawDataBreakdowns = {};
    for (var _i = 0, _o = Object.keys(dataBreakdownHeaders || {}) || []; _i < _o.length; _i++) {
        var key = _o[_i];
        rawDataBreakdowns[key] = {
            headers: dataBreakdownHeaders[key].headers,
            data: [],
        };
    }
    var rawData = ((_e = scoresResponse.data) === null || _e === void 0 ? void 0 : _e.getRawData(rawDataBreakdowns, functionIndexes, indexForLevelId)) || [];
    var nameByLookupCode = __assign(__assign({}, (((_f = overview.data) === null || _f === void 0 ? void 0 : _f.lookupCodeMap) || {})), { "All Projects": "All Projects", "All Functions": "All Functions", "All Levels": "All Levels" });
    var data = rawData
        ? fillEmpties(rawData, xHeaders.length, yHeaders.length, fillEmpty)
        : [[]];
    var dataBreakdowns = ((_g = scoresResponse.data) === null || _g === void 0 ? void 0 : _g.getDataBreakdown(xHeaders.length, rawDataBreakdowns)) ||
        {};
    var returnable = {
        xHeaders: xHeaders,
        yHeaders: yHeaders,
        dataBreakdowns: dataBreakdowns,
        codeTypeMap: (_h = overview.data) === null || _h === void 0 ? void 0 : _h.codeTypeMap,
        data: data,
        riskyTeams: (_k = (_j = risksResponse === null || risksResponse === void 0 ? void 0 : risksResponse.data) === null || _j === void 0 ? void 0 : _j.data) === null || _k === void 0 ? void 0 : _k.high_risk_teams,
        riskyLeaders: (_m = (_l = risksResponse === null || risksResponse === void 0 ? void 0 : risksResponse.data) === null || _l === void 0 ? void 0 : _l.data) === null || _m === void 0 ? void 0 : _m.high_risk_entities,
        nameByLookupCode: nameByLookupCode,
        filters: filters,
        headersConditions: headersConditions,
        scoresConditions: scoresConditions,
    };
    return returnable;
}
export function useHeatmapLeadershipScores(scoreType) {
    return function (_a) {
        var riskRole = _a.riskRole;
        return useHeatmap(useGetLeadershipOverviewQuery, useGetLeadershipScoresQuery, useGetLeadershipRisksQuery, function () { return ({ state: "nodata" }); }, scoreType, riskRole);
    };
}
export function useHeatmapLeadershipAtRiskScores(scoreType) {
    return function (_a) {
        var riskRole = _a.riskRole;
        return useHeatmap(useGetLeaderAtRiskOverviewQuery, useGetLeaderAtRiskScoresQuery, useGetLeadersAtRiskRisksQuery, function () { return ({ state: "nodata" }); }, scoreType, riskRole);
    };
}
export function useHeatmapPositionedSuccessionScores(scoreType) {
    return function (_a) {
        var riskRole = _a.riskRole;
        return useHeatmap(useGetPositionSuccessionOverviewQuery, useGetPositionSuccessionScoresQuery, useGetPositionSuccessionRisksQuery, function () { return ({ state: "nodata" }); }, scoreType, riskRole);
    };
}
export function useHeatmapLeaderedSuccessionScores(scoreType) {
    return function (_a) {
        var riskRole = _a.riskRole;
        return useHeatmap(useGetLeaderedSuccessionOverviewQuery, useGetLeaderedSuccessionScoresQuery, useGetLeaderedSuccessionRisksQuery, function () { return ({ state: "nodata" }); }, scoreType, riskRole);
    };
}
/** Transforms heatmap-aggregation API response into HeatmapScoreData. API returns rowName = xAxis, columnName = yAxis. CreateReport sends xAxis = row dimension, yAxis = column dimension, so display rows = xAxis (API rows), columns = yAxis (API columns) so table matches API and user selection. */
function transformHeatmapAggregationToScoreData(params) {
    var _a;
    var response = params.response, lookupCodeMap = params.lookupCodeMap, heatmapLabels = params.heatmapLabels, fillEmpty = params.fillEmpty, filters = params.filters, scoresConditions = params.scoresConditions;
    if (!(response === null || response === void 0 ? void 0 : response.length)) {
        return {
            xHeaders: [ALL_COL_KEY],
            yHeaders: [ALL_ROW_KEY],
            data: [[fillEmpty()]],
            dataBreakdowns: {},
            codeTypeMap: {},
            riskyTeams: [],
            riskyLeaders: [],
            nameByLookupCode: __assign((_a = {}, _a[ALL_ROW_KEY] = "All ".concat(heatmapLabels === null || heatmapLabels === void 0 ? void 0 : heatmapLabels.xAxis), _a[ALL_COL_KEY] = "All ".concat(heatmapLabels === null || heatmapLabels === void 0 ? void 0 : heatmapLabels.yAxis), _a), lookupCodeMap),
            filters: filters,
            scoresConditions: [scoresConditions],
            headerConditions: [scoresConditions],
        };
    }
    var allColumnIds = new Set();
    var allRowIds = new Set();
    response.forEach(function (row) {
        allRowIds.add(row.rowId);
        row.columns.forEach(function (col) { return allColumnIds.add(col.columnId); });
    });
    var apiRowIdsOrdered = __spreadArray([
        "ALL"
    ], Array.from(allRowIds).filter(function (id) { return id !== "ALL"; }), true);
    var apiColumnIdsOrdered = __spreadArray([
        "ALL"
    ], Array.from(allColumnIds).filter(function (id) { return id !== "ALL"; }), true);
    var rowByApiRowId = new Map(response.map(function (r) { return [r.rowId, r]; }));
    var yHeaders = __spreadArray([
        ALL_ROW_KEY
    ], apiRowIdsOrdered.filter(function (id) { return id !== "ALL"; }), true);
    var xHeaders = __spreadArray([
        ALL_COL_KEY
    ], apiColumnIdsOrdered.filter(function (id) { return id !== "ALL"; }), true);
    var numDisplayCols = xHeaders.length;
    var numDisplayRows = yHeaders.length;
    var data = Array.from({ length: numDisplayRows }, function () {
        return Array.from({ length: numDisplayCols }, function () { return fillEmpty(); });
    });
    for (var displayY = 0; displayY < numDisplayRows; displayY++) {
        var apiRowId = displayY === 0 ? "ALL" : yHeaders[displayY];
        var _loop_1 = function (displayX) {
            var apiColumnId = displayX === 0 ? "ALL" : xHeaders[displayX];
            var apiRow = rowByApiRowId.get(apiRowId);
            var col = apiRow === null || apiRow === void 0 ? void 0 : apiRow.columns.find(function (c) { return c.columnId === apiColumnId; });
            if (col != null && (col.score != null || col.count != null)) {
                data[displayY][displayX] = {
                    score: col.score,
                    count: col.count,
                };
            }
        };
        for (var displayX = 0; displayX < numDisplayCols; displayX++) {
            _loop_1(displayX);
        }
    }
    var nameByLookupCode = __assign({}, lookupCodeMap);
    apiRowIdsOrdered.forEach(function (id) {
        if (id === "ALL") {
            return;
        }
        if (!nameByLookupCode[id]) {
            nameByLookupCode[id] = id;
        }
    });
    apiColumnIdsOrdered.forEach(function (id) {
        if (id === "ALL") {
            return;
        }
        if (!nameByLookupCode[id]) {
            nameByLookupCode[id] = id;
        }
    });
    nameByLookupCode[ALL_ROW_KEY] = "All ".concat(heatmapLabels === null || heatmapLabels === void 0 ? void 0 : heatmapLabels.xAxis);
    nameByLookupCode[ALL_COL_KEY] = "All ".concat(heatmapLabels === null || heatmapLabels === void 0 ? void 0 : heatmapLabels.yAxis);
    return {
        xHeaders: xHeaders,
        yHeaders: yHeaders,
        data: data,
        dataBreakdowns: {},
        codeTypeMap: {},
        riskyTeams: [],
        riskyLeaders: [],
        nameByLookupCode: nameByLookupCode,
        filters: filters,
        scoresConditions: [scoresConditions],
        headerConditions: [scoresConditions],
    };
}
export function useDynamicHeatmapScores(params) {
    var reportId = params.reportId, skillGroup = params.skillGroup, heatmapDimensions = params.heatmapDimensions, heatmapLabels = params.heatmapLabels, fillEmpty = params.fillEmpty, projectNameRenderer = params.projectNameRenderer;
    var rowDimensionKey = heatmapDimensions.xAxis;
    var columnDimensionKey = heatmapDimensions.yAxis;
    return function () {
        var _a;
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        var getFilters = useContext(FilterContext).getFilters;
        var filters = __assign(__assign({}, getFilters()), { scoreType: getFilters().dashboardScoreType });
        var aggregationQuery = useGetHeatmapAggregation({
            reportId: reportId,
            skillGroup: skillGroup,
            filters: filters,
        });
        var lookups = useGetLookupsFiltersQuery({
            clientId: (_b = getClientId()) !== null && _b !== void 0 ? _b : undefined,
        });
        var lookupCodeMap = (_e = (_d = (_c = lookups === null || lookups === void 0 ? void 0 : lookups.data) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.lookupCodeMap) !== null && _e !== void 0 ? _e : {};
        var scoresConditions = {
            isError: !!aggregationQuery.isError,
            isFetching: !!aggregationQuery.isFetching,
        };
        var headersConditions = [aggregationQuery];
        // a hack that should last about 300 years dealing with mixed pure endpoint
        var cohortHeatmapRecallKey = Date.now().toString().slice(0, 9);
        if (getFilters().cohortHeatmapRecallKey !== cohortHeatmapRecallKey) {
            updateFilters({ cohortHeatmapRecallKey: cohortHeatmapRecallKey });
        }
        if (aggregationQuery.isError && !aggregationQuery.isFetching) {
            var emptyDataConditions = {
                isError: false,
                isFetching: false,
            };
            return {
                xHeaders: [ALL_COL_KEY],
                yHeaders: [ALL_ROW_KEY],
                data: [[fillEmpty()]],
                dataBreakdowns: {},
                codeTypeMap: {},
                riskyTeams: [],
                riskyLeaders: [],
                nameByLookupCode: __assign((_a = {}, _a[ALL_ROW_KEY] = (_f = heatmapLabels === null || heatmapLabels === void 0 ? void 0 : heatmapLabels.xAxis) !== null && _f !== void 0 ? _f : "", _a[ALL_COL_KEY] = (_g = heatmapLabels === null || heatmapLabels === void 0 ? void 0 : heatmapLabels.yAxis) !== null && _g !== void 0 ? _g : "", _a), lookupCodeMap),
                filters: __assign(__assign({}, filters), { locations: (_h = filters === null || filters === void 0 ? void 0 : filters.locations) !== null && _h !== void 0 ? _h : [] }),
                scoresConditions: [emptyDataConditions],
                headerConditions: [emptyDataConditions],
            };
        }
        if (willHold(headersConditions)) {
            return {
                xHeaders: [],
                yHeaders: [],
                data: [],
                dataBreakdowns: {},
                codeTypeMap: {},
                riskyTeams: [],
                riskyLeaders: [],
                nameByLookupCode: {},
                filters: __assign(__assign({}, filters), { locations: (_j = filters === null || filters === void 0 ? void 0 : filters.locations) !== null && _j !== void 0 ? _j : [] }),
                scoresConditions: headersConditions,
                headerConditions: headersConditions,
            };
        }
        var response = (_k = aggregationQuery.data) !== null && _k !== void 0 ? _k : [];
        var result = transformHeatmapAggregationToScoreData({
            response: response,
            rowDimensionKey: rowDimensionKey,
            columnDimensionKey: columnDimensionKey,
            heatmapLabels: heatmapLabels,
            lookupCodeMap: lookupCodeMap,
            fillEmpty: fillEmpty,
            filters: __assign(__assign({}, filters), { locations: (_l = filters === null || filters === void 0 ? void 0 : filters.locations) !== null && _l !== void 0 ? _l : [] }),
            scoresConditions: scoresConditions,
        });
        if (projectNameRenderer) {
            if (rowDimensionKey === "project") {
                result.yHeaders.forEach(function (id) {
                    if (id === "ALL" || id === ALL_ROW_KEY || id === ALL_COL_KEY) {
                        return;
                    }
                    result.nameByLookupCode[id] =
                        projectNameRenderer(id);
                });
            }
            if (columnDimensionKey === "project") {
                result.xHeaders.forEach(function (id) {
                    if (id === "ALL" || id === ALL_ROW_KEY || id === ALL_COL_KEY) {
                        return;
                    }
                    result.nameByLookupCode[id] =
                        projectNameRenderer(id);
                });
            }
        }
        return result;
    };
}
